import {useMutation} from "@tanstack/react-query";
import {identityValidateService} from "../services/account/identityValidate.service";

const useIdentityValidate = () => {
  const {mutateAsync, isPending, error, isSuccess, data, reset} = useMutation({
    mutationKey: ["identity-validate"],
    mutationFn: payload => identityValidateService(payload),
  });

  return {
    validateIdentity: mutateAsync,
    isPending,
    error,
    isSuccess,
    data: data?.data,
    reset,
  };
};

export default useIdentityValidate;
